import React from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { Draggable } from 'react-beautiful-dnd'
import { BsFillShareFill } from 'react-icons/bs'
import { HiOutlineUsers } from 'react-icons/hi'
import { AiOutlineTag } from 'react-icons/ai'
import './card.css'

const Card = ({ data, cardIndex, setSlackShareData }) => {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]
  return (
    <Draggable
      draggableId={`card:${data._id}`}
      key={`card:${data._id}`}
      index={cardIndex}
    >
      {({ innerRef, draggableProps, dragHandleProps }) => (
        <div
          {...draggableProps}
          {...dragHandleProps}
          ref={innerRef}
          className='card'
        >
          <button className='share' onClick={() => setSlackShareData(data)}>
            <BsFillShareFill size={14} />
          </button>
          {data.isPrivate && (
            <div className='private-symbol'>
              <img src='/assets/images/lock.png' alt='' />
            </div>
          )}
          <div
            className='content'
            onClick={() =>
              navigate(
                `/tasks/?tag=${
                  searchParams.get('tag') && searchParams.get('tag') !== 'null'
                    ? searchParams.get('tag')
                    : ''
                }&task=${data._id}&card=`
              )
            }
          >
            <div className='header'>
              {data?.meetingTag && (
                <span>
                  <HiOutlineUsers size={10} />
                  {data?.meetingTag}
                </span>
              )}
              {/* {data?.tag?.filter((item) => item)?.length > 0 && (
                <span>
                  <AiOutlineTag size={10} />
                  {data?.tag?.filter((item) => item)?.length > 1
                    ? `${data?.tag?.filter((item) => item)[0]} +${
                        data?.tag?.filter((item) => item).length - 1
                      }`
                    : data?.tag?.filter((item) => item)[0]}
                </span>
              )} */}
            </div>
            <div className='top'>{data.title}</div>
            <div className='bottom'>
              <span>{`${new Date(data.dueDate).getDate()} ${
                months[new Date(data.dueDate).getMonth()]
              }`}</span>
              <span>
                {data?.assignee[0]?.email}{' '}
                {data?.assignee?.length > 1 && `+ ${data.assignee.length - 1}`}
              </span>
            </div>
          </div>
        </div>
      )}
    </Draggable>
  )
}

export default Card
